import { Box, Divider, Grid, Stack, Typography, useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { useEffect, useState } from 'react';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useNavigate } from 'react-router-dom';
import { pagesEnum } from 'constants/ui.constants';
import { CarouselComponent } from 'components/Carousel';
import { SmallCard } from 'theme/elements/Cards';
import { format } from 'date-fns';
import _ from 'lodash';
import { getUserDetails } from 'state/reducers/user.reducers';
import { BalanceType } from 'constants/balance.constants';
import { dataType } from 'components/table/types';
import { pendingRequestsTypes } from 'constants/requests.constants';
import { SwiperSlide } from 'swiper/react';
import { formatNumber } from 'components/FormCreatorComponent/helpers';

export const BONewRequests = ({ requests }) => {
	const theme = useTheme();
	const t = useAppSelector(selectTranslations);
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const [slides, setSlides] = useState<any>(null);
	const { permissions } = useAppSelector(getUserDetails);
	const boSignerPermission = 'bo_signer_main';
	const boSecondaryPermision = 'bo_signer_secondary';

	const handleCardClick = (id: number) => {
		navigate(`/${pagesEnum.COMPANY_FEATURE_PROFILE}/${pendingRequestsTypes.BALANCES}/${id}`);
	};

	const rowAction =
		permissions?.permissions &&
		(permissions.permissions.includes(boSignerPermission) || permissions.permissions.includes(boSecondaryPermision))
			? {
					rowAction: (row: dataType) => {
						if (row.type === BalanceType.Topping || row.type === BalanceType.Withdrawal) {
						}
					},
			  }
			: {};

	useEffect(() => {
		if (requests?.length > 0) {
			let gradientInitialPercent = 100;
			const cards = requests.map((item: any, index: number) => {
				const gradientPercent = gradientInitialPercent;
				gradientInitialPercent = gradientInitialPercent === 70 ? 100 : gradientInitialPercent - 10;
				const card = (
					<SwiperSlide key={index}>
						<Grid
							item
							xs={8}
							sm={'auto'}
							key={index}
							sx={{
								overflow: 'hidden',
								height: 'max-content',
								transform: 'scalex(-1)',
								direction: 'rtl',
								textAlign: 'left',
							}}
						>
							<SmallCard
								key={index}
								styleObj={{
									display: 'flex',
									flexDirection: 'row',
									justifyContent: 'space-between',
									color: theme.palette.root.basicWhite,
									backgroundColor: `rgba(0,58,53,${index % 4 > 0 ? '0.' + (10 - (index % 4)) : 1})`,
									position: 'relative',
									cursor: 'pointer',
								}}
								handleClick={() => handleCardClick(item.id)}
							>
								<Stack width="100%" sx={{ transform: 'scalex(-1)', alignItems: 'end' }}>
									<Stack direction="row" alignItems="center" spacing={1}>
										<Typography variant="boldBody4">
											{t('page.dashboard.boSigner.requests.field.amount')}
										</Typography>
									</Stack>
									<Typography variant="boldBody3">
										{item.currency.symbol}
										{formatNumber(item?.amount)}
									</Typography>
									<Stack sx={{ marginTop: '20px' }} width="100%">
										<Stack direction="row" justifyContent="space-between">
											<Typography variant="boldBody4">
												{t(
													`page.dashboard.boSigner.requests.transferType.${_.camelCase(
														item.type
													)}`
												)}
											</Typography>
											<Typography variant="boldBody4">
												{t('page.dashboard.boSigner.requests.field.transferOrigin')}
											</Typography>
										</Stack>
										<Divider
											orientation="horizontal"
											flexItem
											sx={{
												marginTop: '12px',
												borderBottom: 1,
												borderColor: theme.palette.root.white,
											}}
										/>
										<Stack
											marginTop="12px"
											direction="row"
											justifyContent="space-between"
											width="100%"
										>
											<Typography variant="boldBody4">
												{format(new Date(item.createdAt), 'dd.MM.yyyy')}
											</Typography>
											<Typography variant="boldBody4">
												{t('page.dashboard.boSigner.requests.field.createdAt')}
											</Typography>
										</Stack>
									</Stack>
								</Stack>

								<img
									src="/icons/logo-brand-icon.svg"
									style={{
										filter: 'brightness(0) invert(1)',
										opacity: '0.3',
										position: 'absolute',
										right: '3%',
										bottom: '3%',
										transform: 'scalex(-1)',
									}}
								/>
							</SmallCard>
						</Grid>
					</SwiperSlide>
				);
				return card;
			});
			setSlides(cards);
		} else {
			setSlides(null);
		}
	}, [requests]);

	const createCardsArray = (cards: any[], size: number) => {
		const chunks = [];
		const items = [].concat(...cards);
		// eslint-disable-next-line functional/no-loop-statements
		while (items.length) {
			chunks.push(items.splice(0, size));
		}
		return chunks;
	};

	return (
		<Stack>
			<Box>
				<Typography variant="h4" sx={{ fontWeight: 700, color: theme.palette.common.black }}>
					{t('page.dashboard.boSigner.newRequests.title')}
				</Typography>
				<Typography variant="subtitle" sx={{ color: theme.palette.root.grey }}>
					{`${requests?.length || 0} ${t('page.dashboard.boSigner.newRequests.subtitle')}`}
				</Typography>
			</Box>
			{slides?.length > 0 && (
				<Box sx={{ marginTop: '16px' }}>
					<CarouselComponent>{slides}</CarouselComponent>
				</Box>
			)}
		</Stack>
	);
};
